import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { MessageRetailerOrBrandButton } from "../../shared/instantAnswerUtils";
import { countryToISO } from "../../utils/countryToISO";
import { getShipFromCountryForOrder } from "../../utils/getShipFromCountryForOrder";
import { getShipFromCountryForBrand } from "../../utils/getShippingFromCountryForBrand";
import { isSWFAvailableInCountry } from "../../utils/isSWFAvailableInCountry";
export var HowShippingWorks = function HowShippingWorks(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: [ShippingContextDataFn]
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var _getShipFromCountryFo;
  var shipFromCountry = (_getShipFromCountryFo = getShipFromCountryForOrder(context)) !== null && _getShipFromCountryFo !== void 0 ? _getShipFromCountryFo : getShipFromCountryForBrand(context.brand);
  var shipFromCountryISO = countryToISO(shipFromCountry);
  return isSWFAvailableInCountry(shipFromCountryISO) ? SwfAvailableScenario(strictLocalize) : SwfNotAvailableScenario(strictLocalize);
};
var SwfAvailableScenario = function SwfAvailableScenario(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_OPTIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE(strictLocalize), OLD_SHIP_WITH_FAIRE_DEFINITION(strictLocalize), OLD_SHIP_ON_YOUR_OWN_DEFINITION(strictLocalize)];
    }
  };
};
var SwfNotAvailableScenario = function SwfNotAvailableScenario(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_OPTIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_CAN_USE_YOUR_OWN_CARRIER(strictLocalize)];
    }
  };
};
var SHIPPING_OPTIONS = function SHIPPING_OPTIONS(strictLocalize) {
  return strictLocalize({
    id: "UGEH5X",
    defaultMessage: [{
      "type": 0,
      "value": "Verzendopties"
    }]
  });
};
var OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE = function OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE(strictLocalize) {
  return strictLocalize({
    id: "cITe5h",
    defaultMessage: [{
      "type": 0,
      "value": "Als je klaar bent om je bestelling te verzenden, kun je kiezen voor Verzenden met Faire of Met eigen vervoerder verzenden."
    }]
  });
};
var YOU_CAN_USE_YOUR_OWN_CARRIER = function YOU_CAN_USE_YOUR_OWN_CARRIER(strictLocalize) {
  return strictLocalize({
    id: "ctr/F1",
    defaultMessage: [{
      "type": 0,
      "value": "Wanneer je klaar bent om te verzenden kun je je eigen vervoerder gebruiken om deze bestelling te versturen. Je voert gewoon de verzendkosten en het trackingnummer in ons systeem in zodra deze beschikbaar zijn en we vergoeden de verzendkosten tijdens de uitbetaling van je bestelling."
    }]
  });
};
var OLD_SHIP_WITH_FAIRE_DEFINITION = function OLD_SHIP_WITH_FAIRE_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "pgJwpA",
    defaultMessage: [{
      "type": 0,
      "value": "Verzenden met Faire stelt je in staat je verzendetiketten via Faire af te drukken om lage vervoerderstarieven te ontvangen terwijl je geen verzendkosten betaalt. We registreren automatisch de verzendkosten en het volgnummer van de zending om je tijd te besparen. "
    }]
  });
};
var OLD_SHIP_ON_YOUR_OWN_DEFINITION = function OLD_SHIP_ON_YOUR_OWN_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "FAgUqw",
    defaultMessage: [{
      "type": 0,
      "value": "Via Met eigen vervoerder verzeken kun je de verzending zelf verzorgen. Je kunt je eigen vervoerder gebruiken om deze bestelling te verzenden: voer de verzendkosten en het trackingnummer in ons systeem in zodra deze beschikbaar zijn en we vergoeden de verzendkosten met je totale besteluitbetaling."
    }]
  });
};